import SectionProvider from '@builder/sections/SectionProvider'

export const name = 'Featured Post'
export const group = 'Dynamic Post Template'
export const beta = false

export const defaultOptions = {
  content: {
    data: {
      post: null,
      type: 'featured-post-mod'
    }
  }
}

export const icon = `
`

export default class ElPostCategories extends SectionProvider {
  constructor (options = {}) {
    super('ElFeaturedPost', options)

    this.name = name
    this.group = group
    this.defaultOptions = defaultOptions
  }
}
